import React, { useState, useEffect } from 'react';
import Mixpanel from '../utils/mixpanel';
import Breathwork from './Breathwork';
import Relaxation from './Relaxation';
import ConcentrationGrid from './ConcentrationGrid';

const Focus = () => {
  const [activeFocus, setActiveFocus] = useState('breathwork');
  
  useEffect(() => {
    // Use the enhanced page tracking instead of generic feature tracking
    Mixpanel.trackEnhancedPageView('/focus', 'Focus Tools', {
      feature: 'Focus',
      action: 'Opened',
      active_tool: activeFocus
    });
  }, []);
  
  const handleFocusChange = (focus) => {
    setActiveFocus(focus);
    
    // Use the enhanced feature action tracking
    Mixpanel.trackEnhancedFeatureAction('Focus', 'Tool Selected', {
      tool: focus,
      timestamp: new Date().toISOString()
    });
  };

  return (
    <div className="w-full">
      <div className="grid grid-cols-1 gap-6">
      {/* Quick Action Menu */}
      <div className="flex justify-center mb-8">
        <div className="inline-flex rounded-md shadow-sm" role="group">
          <button
            type="button"
            onClick={() => handleFocusChange('breathwork')}
            className={`px-4 py-2 text-sm font-medium rounded-l-lg ${
              activeFocus === 'breathwork'
                ? 'bg-blue-600 text-white'
                : 'bg-white text-gray-700 hover:bg-gray-100 hover:text-blue-700'
            } border border-gray-200`}
          >
            Breathwork
          </button>
          <button
            type="button"
            onClick={() => handleFocusChange('relaxation')}
            className={`px-4 py-2 text-sm font-medium ${
              activeFocus === 'relaxation'
                ? 'bg-blue-600 text-white'
                : 'bg-white text-gray-700 hover:bg-gray-100 hover:text-blue-700'
            } border-t border-b border-gray-200`}
          >
            Relaxation
          </button>
          <button
            type="button"
            onClick={() => handleFocusChange('concentration')}
            className={`px-4 py-2 text-sm font-medium rounded-r-lg ${
              activeFocus === 'concentration'
                ? 'bg-blue-600 text-white'
                : 'bg-white text-gray-700 hover:bg-gray-100 hover:text-blue-700'
            } border border-gray-200`}
          >
            Concentration
          </button>
        </div>
      </div>

      {/* Focus Content */}
      <div>
        {activeFocus === 'breathwork' && <Breathwork />}
        {activeFocus === 'relaxation' && <Relaxation />}
        {activeFocus === 'concentration' && <ConcentrationGrid />}
      </div>
      </div>
    </div>
  );
};

export default Focus;